import { Nodes } from '@ametista-ai/editor/constants';
import { toggleBlockType, toggleList } from '@ametista-ai/editor/utils';
import { useEditorEventCallback } from '@handlewithcare/react-prosemirror';

export function useToggleEditorNode(node: Nodes, attrs?: Record<string, unknown>) {
  return useEditorEventCallback((view) => {
    if (!view) {
      return;
    }

    if (node === 'bullet_list' || node === 'ordered_list') {
      toggleList(view.state.schema.nodes[node], view.state.schema.nodes['list_item'])(
        view.state,
        view.dispatch
      );
    } else {
      toggleBlockType(node, 'paragraph', attrs)(view.state, view.dispatch);
    }

    view.focus();
  });
}
